import getBasicItemTypeHandler from '@blaze-cms/utils/src/item-type-handlers/basic-item-type-handler';
import { PROVIDER_TYPE_NAME, REQUIRED_PROPERTIES } from '../constants';
import { LOGIN_MUTATION } from '../mutations';
import handleLogin from './handle-login';
import getApiCredentialsSetting from './get-api-credentials-setting';

const getProviderHandler = () => {
  const baseHandler = getBasicItemTypeHandler(PROVIDER_TYPE_NAME, {
    requiredProperties: REQUIRED_PROPERTIES
  });

  let providerOrder;
  let autoLoginDone = false;

  function setProviderOrder(order) {
    providerOrder = order;
  }

  function getInOrder(order = providerOrder) {
    if (!order || !order.length) return baseHandler.getAll();

    return order.map(providerKey => baseHandler.get(providerKey)).filter(Boolean);
  }

  function getProviderLoginVariables(key, variables) {
    return { input: { ...variables, provider: key } };
  }

  async function autoLogin(client, ctx) {
    if (autoLoginDone) return; // stops autoLogin running more than once

    await Promise.all(
      getInOrder().map(async ({ key, getAutoLoginData, afterAutoLogin }) => {
        if (!getAutoLoginData) return null;

        try {
          const authData = await getAutoLoginData({ ctx });
          if (authData) {
            autoLoginDone = true; // if an auto login is attempted, we don't want to try again
            const { data } = await client.mutate({
              mutation: LOGIN_MUTATION,
              variables: getProviderLoginVariables(key, authData),
              context: { credentials: getApiCredentialsSetting() }
            });
            await handleLogin(data, client);
            if (afterAutoLogin) return afterAutoLogin({ data, client, ctx });
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e);
        }
        return null;
      })
    );
    if (ctx) autoLoginDone = true; // only set to true if ctx is true so all providers have a chance to autoLogin
  }

  return {
    ...baseHandler,
    setupComplete: false,
    getInOrder,
    setProviderOrder,
    getProviderLoginVariables,
    autoLogin
  };
};

export default getProviderHandler();
